import React from 'react';
import { Select } from 'components';
import { yesNoSort } from 'utils/sort/yes-no-sort';
import clsx from 'clsx';
import { IListTextFilter } from './list-text';

export const SelectFilter: React.FC<IListTextFilter> = (props): JSX.Element => {
    const {
        filter,
        onFilterChange,
        sortListItems = yesNoSort,
        className
    } = props;

    let { values }: { values: string[] } = filter;
    if (sortListItems) {
        values = values.sort(sortListItems);
    }

    const handleChange = (variants) => {
        onFilterChange(filter.id, variants.length === 0 ? null : variants);
    };

    const options = values.map((v) => ({
        value: v,
        label: v.replace('&#x27;', "'").replace(/&quot;/g, '"')
    }));
    return (
        <div className={clsx('objects-filter', className)}>
            { !!filter.name && (
                <div className="objects-filter__name">{filter.name}</div>
            ) }
            <Select
                mode='multiple'
                onChange={handleChange}
                values={filter.value}
                options={options}
            />
        </div>
    );
};
